'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactCssThemr = require('react-css-themr');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _reactCssThemr.ThemeProvider;
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/lib/ThemeProvider.js
// module id = 84
// module chunks = 0